import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import 'normalize.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn:
      'https://6d8b35a62f804291821c88389f77858f@o428931.ingest.sentry.io/5374795',
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
